
        import '/home/builduser/work/97f164ade279074e/santa-editor/packages/textEditor/textEditor.scss.css.virtualfile';
        module.exports = {"textEditor__pimple":"_textEditor__pimple_dhq68_1","textEditorPimple":"_textEditor__pimple_dhq68_1"};